import { insertLinkByQuickSearchCommand } from '@blocksuite/hive-block-bookmark';
import { menu } from '@blocksuite/hive-components/context-menu';
import { LinkIcon } from '@blocksuite/hive-components/icons';
import { TelemetryProvider } from '@blocksuite/hive-shared/services';
import type { DenseMenuBuilder } from '@blocksuite/hive-widget-edgeless-toolbar';

export const buildLinkDenseMenu: DenseMenuBuilder = edgeless =>
  menu.action({
    name: 'Link',
    prefix: LinkIcon,
    select: () => {
      const [_, { insertedLinkType }] = edgeless.std.command.exec(
        insertLinkByQuickSearchCommand
      );

      insertedLinkType
        ?.then(type => {
          const flavour = type?.flavour;
          if (!flavour) return;

          edgeless.std
            .getOptional(TelemetryProvider)
            ?.track('CanvasElementAdded', {
              control: 'toolbar:general',
              page: 'whiteboard editor',
              module: 'toolbar',
              type: flavour.split(':')[1],
            });
        })
        .catch(console.error);
    },
  });
